export enum ENUM_AUTH_TYPES {
  ONLY_PUBLIC = "onlyPublic",
  PUBLIC = "public",
  PRIVATE = "private",
}

export enum ENUM_LAYOUT_TYPES {
  ROOT = "root",
  ADMIN = "admin",
}
